<template>
    <div class="rating-container">
        <i  
            v-for="starIndex in 5" 
            :key="starIndex"
            class="fa-kit fa-trustpilot fa-xs rating"
            :class="getStarClass(starIndex, Number(score))"
        />
    </div>
</template>

<script>
export default {
    props: {
        score: {
            type: String,
            required: true,
        }
    },
    methods: {
        getStarClass(starIndex, score) {
            const roundedScore = Math.round(score * 2) / 2;
            const halfStarIndex = Math.floor(roundedScore) + 1;
            const hasHalfStar = roundedScore % 1 !== 0;

            if (starIndex <= roundedScore) {
                return 'bg-success';
            }

            if (starIndex === halfStarIndex && hasHalfStar) {
                return 'bg-half-success';
            }

            return '';
        }
    }
};
</script>

<style lang="scss" scoped>            
    .rating-container {
        display: flex;
        gap: 1px;
        .rating {
            color: $white;
            background-color: $trustpilotGray;
            padding: 0.25rem;
            &.bg-success {
                background-color: $trustpilotGreen;
            }
            &.bg-half-success {
                background: linear-gradient(to left, $trustpilotGray 50%, $trustpilotGreen 50%);
            }
        }
    }
</style>
